var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme-switcher"},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"theme-toggle-btn",attrs:{"icon":""},on:{"click":_vm.toggleTheme}},'v-btn',attrs,false),on),[_c('v-icon',{class:{ 'rotate-icon': _vm.animating }},[_vm._v(" "+_vm._s(_vm.currentIcon)+" ")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltipText))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }